<template>
  <v-select
    :autofocus="autofocus"
    :id="id || 'announcement-type'"
    :rules="rules"
    :items="announcementTypes"
    item-value="id"
    item-title="name"
    :label="label || 'Typ oznámení'"
    :model-value="value"
    :clearable="clearable"
    @update:model-value="onChange"
    variant="underlined"
    color="#78BE13"
  ></v-select>
</template>

<script setup>

defineProps({
  /**
   * ID passed to the input.
   */
  id: String,
  /**
   * Array of announcement types objects.
   */
  announcementTypes: Array,
  /**
   * Identifies if the select is clearable.
   */
  clearable: Boolean,
  /**
   * Input label.
   */
  label: String,
  /**
   * Input validation rules.
   */
  rules: Array,
  /**
   * Input value.
   */
  value: Number,
  /**
   * Input autofocus.
   */
  autofocus: Boolean
})
const emit = defineEmits(['change'])

function onChange(value){
  emit('change', value);
}
</script>

<style scoped>
</style>